import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79185675"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "card-item card-left"
}
const _hoisted_3 = { class: "card-center" }
const _hoisted_4 = {
  key: 0,
  class: "card-header-slot"
}
const _hoisted_5 = { class: "card-item card-header-slot-content --left" }
const _hoisted_6 = {
  key: 0,
  class: "card-item card-header-slot-content --right"
}
const _hoisted_7 = {
  key: 1,
  class: "card-item card-body-slot"
}
const _hoisted_8 = {
  key: 2,
  class: "card-item card-footer-slot"
}
const _hoisted_9 = {
  key: 1,
  class: "card-item card-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_card_cell = _resolveComponent("oxd-card-cell")!
  const _component_oxd_card_tr = _resolveComponent("oxd-card-tr")!
  const _component_oxd_card_tbody = _resolveComponent("oxd-card-tbody")!

  return (_openBlock(), _createBlock(_component_oxd_card_tbody, { class: "oxd-card-table-body" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableProps.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(_ctx.classes),
          key: item,
          onClick: ($event: any) => (_ctx.onClick(item)($event))
        }, [
          _createVNode(_component_oxd_card_tr, {
            clickable: _ctx.tableProps.clickable
          }, {
            default: _withCtx(() => [
              (_ctx.leftSlot.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_oxd_card_cell, {
                      index: index,
                      headers: _ctx.leftSlot,
                      items: item
                    }, null, 8, ["index", "headers", "items"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                (_ctx.titleSlot.length != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_oxd_card_cell, {
                          index: index,
                          headers: _ctx.titleSlot,
                          items: item
                        }, null, 8, ["index", "headers", "items"])
                      ]),
                      (_ctx.actionSlot.length != 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_oxd_card_cell, {
                              index: index,
                              headers: _ctx.actionSlot,
                              items: item
                            }, null, 8, ["index", "headers", "items"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.defaultSlot.length != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_oxd_card_cell, {
                        index: index,
                        headers: _ctx.defaultSlot,
                        items: item
                      }, null, 8, ["index", "headers", "items"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.footerSlot.length != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_oxd_card_cell, {
                        index: index,
                        headers: _ctx.footerSlot,
                        items: item
                      }, null, 8, ["index", "headers", "items"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.rightSlot.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_oxd_card_cell, {
                      index: index,
                      headers: _ctx.rightSlot,
                      items: item
                    }, null, 8, ["index", "headers", "items"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["clickable"])
        ], 10, _hoisted_1))
      }), 128))
    ]),
    _: 1
  }))
}